import { components } from 'react-select'
import styles from '../styles.module.css'

function GroupHeading({ children, ...props }) {
  return (
    <div className={styles.valueLabelContainer}>
      <components.GroupHeading {...props}>
        <span className={styles.valueLabel}>{children}</span>
      </components.GroupHeading>
    </div>
  )
}

export default GroupHeading
